import Vue from 'vue';
import Router from 'vue-router';
import store from './store/index';
import util from './script/util';
import routers1 from './router-gy';
import routers2 from './router-ytl';
import routers3 from './router-ls';
import routers4 from './router-zy';
import routers5 from './router-hgc';
import routers6 from './router-hgb';
import noticeRouters from './router-notice';
import routersActivites from './router-activities';
import routersStatic from './router-static';
import routersPlayer from './router-player';
import { Toast } from 'vant';
import MyLog from '@/script/my-log.js';
import i18n from '@/i18n';
import { updateThemeForRoute } from '@/script/theme';

Vue.use(Router);

const normalizePlayerUuid = uuid => {
  if (uuid === undefined || uuid === null) return '';
  const value = String(uuid).trim();
  return value && value !== 'undefined' && value !== 'null' ? value : '';
};

const abortPlayerDetailEnter = (from, next) => {
  Toast.clear();
  if (from && from.name) {
    next(false);
  } else {
    next('/home');
  }
};

/**
 * meta配置項：
 * keepAlive: <Boolean> 緩存頁面 <keep-alive>，注意如果要处理滚动位置记录，需要在页面生命周期取 meta.scrollTop 手动触发滚动
 * waitUserInfo: <Boolean> 等待用户信息 /user/info 获取完毕后才进入路由页面（!!注意不是校验登录）
 * abTest: <Boolean> 整个页面 abTest，重定向到 ${path}-new 页面
 * ! cache、level 都已去除，不要配置
 */

const routes = [
  {
    path: '/kyc',
    name: 'kycVerification',
    component: () => import(/* webpackChunkName: "kyc" */ './pages/kyc/index.vue')
  },
  ...routers1,
  ...routers2,
  ...routers3,
  ...routers4,
  ...routers5,
  ...routers6,
  ...routersActivites,
  ...noticeRouters,
  ...routersStatic,
  ...routersPlayer,
  // 新首页
  // {
  //   path: '/home',
  //   name: 'homePage',
  //   component: () =>
  //     import(/* webpackChunkName: "home-page" */ './pages/home/index.vue'),
  //   meta: {
  //     keepAlive: true
  //   },
  //   beforeEnter: (to, from, next) => {
  //     if (process.env.VUE_APP_ENV === 'review') {
  //       next('/home-new');
  //     } else {
  //       next();
  //     }
  //   }
  // },
  // 新首页
  {
    path: '/home',
    name: 'newHomePage',
    component: () =>
      import(/* webpackChunkName: "home-page" */ './pages/home-new/index.vue'),
    meta: {
      keepAlive: true
    }
  },
  // 派对
  {
    path: '/party',
    name: 'party',
    component: () =>
      import(/* webpackChunkName: "party" */ './pages/party/index.vue'),
    meta: {
      keepAlive: true
    }
  },
  // 個人中心
  {
    path: '/user-center',
    name: 'userCenter',
    component: () =>
      import(/* webpackChunkName: "user-center" */ './pages/new-user-center'),
    meta: {
      waitUserInfo: true
    }
  },
  // 旧版個人中心
  {
    path: '/old-user-center',
    name: 'OldUserCenter',
    component: () =>
      import(/* webpackChunkName: "user-center" */ './pages/user-center'),
    meta: {
      waitUserInfo: true
    }
  },
  // 个人详情页
  {
    path: '/player-detail',
    name: 'playerDetail',
    component: () =>
      import(/* webpackChunkName: "player-detail" */ './pages/player-detail'),
    beforeEnter(to, from, next) {
      if (normalizePlayerUuid(to.query && to.query.uuid)) {
        next();
        return;
      }
      abortPlayerDetailEnter(from, next);
    }
  },
  // 个人详情页
  {
    path: '/player-detail/:aliasName',
    name: 'AliasNamePlayerDetail',
    component: () =>
      import(/* webpackChunkName: "player-detail" */ './pages/player-detail'),
    beforeEnter(to, from, next) {
      if (normalizePlayerUuid(to.params && to.params.aliasName)) {
        next();
        return;
      }
      abortPlayerDetailEnter(from, next);
    }
  },
  // 陪玩師列表
  {
    path: '/player-list',
    name: 'playerList',
    redirect: { name: 'playerListNew' },
    // component: () =>
    //   import(/* webpackChunkName: "player-list" */ './pages/player-list/index'),
    meta: {
      keepAlive: true
    }
  },
  // 陪玩師列表
  {
    path: '/player-list-new',
    name: 'playerListNew',
    component: () =>
      import(/* webpackChunkName: "player-list-new" */ './pages/player-list-new/index'),
    meta: {
      keepAlive: false
    }
  },
  // 陪玩師專題列表
  {
    path: '/player-topic',
    name: 'playerTopic',
    component: () =>
      import(/* webpackChunkName: "player-topic" */ './pages/player-topic/index'),
    meta: {
      keepAlive: true
    }
  },
  // 新人體驗區
  {
    path: '/player-new',
    name: 'playerNew',
    component: () =>
      import(/* webpackChunkName: "player-new" */ './pages/player-new'),
    meta: {
      keepAlive: true
    }
  },
  // 發現老闆（发现好头家）
  {
    path: '/player-findc',
    name: 'playerFindC',
    component: () =>
      import(/* webpackChunkName: "player-findc" */ './pages/user-center/findc')
  },
  // 全部技能 - 浏览
  {
    path: '/skill-all',
    name: 'skillAll',
    component: () =>
      import(/* webpackChunkName: "skill-all" */ './pages/skill-all/view')
  },
  // 全部技能 - 編輯常用技能
  {
    path: '/skill-add',
    name: 'skillAdd',
    component: () =>
      import(/* webpackChunkName: "skill-add" */ './pages/skill-all/edit'),
    meta: {
      waitUserInfo: true
    }
  },
  // 模糊搜索 - 搜索功能優化
  {
    path: '/search-optimize',
    name: 'optimize',
    component: () =>
      import(/* webpackChunkName: "search-optimize" */ './pages/search-optimize/index'),
    meta: {
      waitUserInfo: true
    }
  },
  // 模糊搜索 - 自由技能市集
  {
    path: '/search-fairlist',
    name: 'fairlist',
    component: () =>
      import(/* webpackChunkName: "search-fairlist" */ './pages/search-optimize/fairlist')
  },
  // 本照认证，结果页面
  {
    path: '/face-ready',
    name: 'faceResult',
    component: () =>
      import(/* webpackChunkName: "face-ready" */ './pages/user-center/face-ready')
  },
  // 动态广场（一级页）
  {
    path: '/feed-list',
    name: 'feedList',
    component: () =>
      import(/* webpackChunkName: "feed-list" */ './pages/feed-list'),
    meta: {
      keepAlive: true
    }
  },
  // 直播播放器
  {
    path: '/live-player',
    name: 'livePlayer',
    component: () =>
      import(/* webpackChunkName: "live-player" */ './pages/live-player/index.vue')
  },
  // 新人专区
  {
    path: '/newcomer-zone',
    name: 'newcomerZone',
    component: () =>
      import(/* webpackChunkName: "newcomer-zone" */ './pages/newcomer-zone'),
    meta: {
      keepAlive: true
    }
  },
  // 免费优惠券专区
  {
    path: '/free-coupon-zone',
    name: 'freeCouponZone',
    component: () =>
      import(/* webpackChunkName: "free-coupon-zone" */ './pages/free-coupon-zone'),
    meta: {
      keepAlive: true
    }
  },
  // Yomi 游戏大厅
  {
    path: '/yomi',
    name: 'Yomi',
    component: () =>
      import(/* webpackChunkName: "yomi" */ './pages/yomi'),
    meta: {
      waitUserInfo: true
    }
  },
  // 重定向到陪玩师详情，使用别名查找陪玩师
  {
    path: '/:pathMatch(.+)',
    redirect: to => {
      console.log(to);
      return {
        name: 'AliasNamePlayerDetail',
        params: { aliasName: to.path.slice(1) }
      };
    }
  }
];

const router = new Router({
  routes
});

// 重寫replace方法
const replaceHandler = Router.prototype.replace;
Router.prototype.replace = function() {
  store.commit('app/UPDATE_ROUTER_REPLACE', true);
  return replaceHandler.apply(this, Array.from(arguments));
};
router.beforeEach(async (to, from, next) => {
  try {
    Toast.loading({
      message: i18n.t('home_loading') + '...',
      forbidClick: true,
      duration: 0
    });
    const { globalRegion } = to.query;
    if (globalRegion) {
      window.sessionStorage.setItem('globalRegion', globalRegion);
    }
    // 斷網狀態
    const isOffline =
      navigator && typeof navigator.onLine === 'boolean' && !navigator.onLine;
    store.dispatch('app/setOffline', !!isOffline);

    const stateUser = store.state.user;
    const hisToken = stateUser.token || '';
    if (to.query) {
      let newToken = to.query.token;
      let activeToken = hisToken;
      const tokenType = Object.prototype.toString.call(newToken);
      if (tokenType === '[object Undefined]' || tokenType === '[object Null]') {
        // 未傳遞token，認為是h5之間跳轉，則不更新信息
      } else if (newToken === 'undefined' || newToken === 'null') {
        // 容錯處理
        newToken = '';
        activeToken = '';
      } else {
        if (hisToken !== newToken) {
          // console.log('改變了當前用戶信息，清空全局記錄的userInfo')
          // console.log('oldToken: ', hisToken)
          // console.log('newToken: ', newToken)
          // console.log(window.location.href)
          // userInfo發生改變，清空已存儲的用戶信息
          store.dispatch('user/clearUserInfo');
        }
        // 不管改沒改變，更新token
        store.dispatch('user/setToken', to.query.token);
        store.dispatch('user/setRefreshToken', to.query.refresh_token);
        activeToken = newToken;
      }
      if (activeToken) {
        // 已登錄，做如下邏輯處理（第一次建立webview，或改變了帳號信息）
        let userInfo = store.state.user.userInfo;
        if (!userInfo) {
          // native已登錄，h5未登錄
          if (to.meta.waitUserInfo) {
            const result = await store.dispatch('user/setUser');
            if (!result) {
              // 接口失敗，認為網絡錯誤（offline）
              store.dispatch('app/setOffline', true);
            }
            // abTest
            userInfo = stateUser.userInfo;
            if (
              to.meta.abTest &&
              userInfo &&
              (userInfo.uuid % 2 === 1 || userInfo.uuid == 233456)
            ) {
              router.replace({
                path: to.path + '-new',
                query: to.query
              });
            }
          } else {
            store.dispatch('user/setUser');
          }
        } else {
          // native已登錄，h5也已登錄（喚醒webview）
          if (to.meta.abTest && userInfo.uuid % 2 === 1) {
            router.replace({
              path: to.path + '-new',
              query: to.query
            });
          }
          if (from.name == 'orderSubmit') {
            // 从订单页跳转其他页面，更新userInfo
            store.dispatch('user/setUser');
          }
        }
      }
    }
    // keepAlive頁面，記錄滾動位置
    if (from.meta.keepAlive) {
      const $content = document.querySelector('#teamup-layout');
      const scrollTop = $content ? $content.scrollTop : 0;
      from.meta.scrollTop = scrollTop;
    }

    // 跳轉路由
    next();
  } catch (error) {
    console.log(error);
    MyLog.captureException('router-beforeEach', {
      context: error
    });
    store.dispatch('app/setRequestError', true);
    // 跳轉路由
    next();
  }
});

router.afterEach((to, from) => {
  updateThemeForRoute(to);
  Toast.clear({
    message: i18n.t('home_loading') + '...',
    forbidClick: true,
    duration: 0
  });
  // util.nativePie('HIDDEN_RETRY_VIEW');

  // if (from.path === '/') {
  //   const GET_COMMON_PARAMS = 'GET_COMMON_PARAMS'
  //   if (!window.sessionStorage.getItem(GET_COMMON_PARAMS)) {
  //     window.sessionStorage.setItem(GET_COMMON_PARAMS, 'true')
  //     util.nativePie('CLIENT_COMMPARAMS')
  //   }
  // }

  // 管理routesHistory
  const { routesHistory, routerReplace } = store.state.app;
  const toIndex = routesHistory.indexOf(to.path);
  const fromIndex = routesHistory.indexOf(from.path);
  if (toIndex !== -1 && fromIndex !== -1) {
    // 页面后退
    routesHistory.splice(fromIndex, 1);
  } else if (toIndex === -1) {
    if (routerReplace) {
      routesHistory[fromIndex] = to.path;
    } else {
      // 新增页面
      routesHistory.push(to.path);
    }
  }
  store.commit('app/UPDATE_ROUTER_REPLACE', false);
  store.commit('app/UPDATE_ROUTES_HISTORY', routesHistory);
  const prePageInfoStr = localStorage.getItem('prepage');
  let prePageInfo = {};
  if (prePageInfoStr) {
    prePageInfo = JSON.parse(prePageInfoStr);
    localStorage.removeItem('prepage');
    window.prePageInfo = prePageInfo;
  }
  if (window.prePageInfo && to.name === window.prePageInfo.firstPage) {
    router.prePageInfo = window.prePageInfo;
  } else {
    router.prePageInfo = {
      prePage: from.fullPath,
      preRouterName: from.name,
      firstPage: to.name
    };
    window.prePageInfo = '';
  }
});

router.onError(err => {
  console.log(err);
});

export default router;
